<template>
	<div class="cotent_weld">
		<div class="content_top">
			<img :src="category.dingimg" alt="" class="w100">
			<!-- <h3>{{category.cat_name}}</h3> -->
			</div>
			<div class="content_center">
				<div class="container">
					<h3>{{category.cat_name}}</h3>
					<!-- <h4>Hisan offers a range of premium quality weld overlay clad wear plates.</h4> -->
					<p>{{category.description}}
			        </p>
				
			</div>
			
		</div>
		
		<div class="tips3">
			
			<div class="container">
				<h3>Ассортимент продукций</h3>
				<ul class="tips3List">
					<li v-for="(item,index) in tips3List" :key="index"  @click="golink(item.id)">
						<img :src="item.image" alt="" class="tisp3_img"/>
						<div class="text_bottom">
							<div class="tips3_text">
								<h4>{{item.title}}</h4>
								<p>{{item.overview}}</p>
							</div>
							<div class="buttom">
								<img src="@/assets/images/index/jt_r.png" alt="" />
								<span>Читать далее</span>
							</div>
						</div>
					</li>
				</ul>	
			</div>
			
		</div>
		<div class="list_box">
			<div class="container">
                <h3>Характеристики</h3>
				<ul>
					<li>
						<img src="@/assets/images/welding/icon_1.png" alt="">
						<!-- <h4>Quality control</h4> -->
						<p class="ts">Превосходная эффективность осаждения</p>
					</li>
					<li>
						<img src="@/assets/images/welding/icon_2.png" alt="">
						<!-- <h4>Combination of metallurgy</h4> -->
						<p class="ts">Плавная работа, ровная дуга, низкое разбрызгивание, минимальное количество шлака</p>
					</li>
					<li>
						<img src="@/assets/images/welding/icon_3.png" alt="">
						<!-- <h4>Deposition efficiency</h4> -->
						<p class="ts">Идеальный выбор для работы в полевых условиях или на объекте</p>
					</li>
					<li>
						<img src="@/assets/images/welding/icon_4.png" alt="">
						<!-- <h4>Full range of categories</h4> -->
						<p class="ts">Отличная устойчивость к различным промышленным применениям</p>
					</li>
					
				</ul>
			</div>
		</div>
        <div class="pro_box">
			<div class="container">
				
				<h3>Спецификация</h3>
				
                <table border="0" cellspacing="0" style="width: 100%;border-collapse:collapse;">
                                   <tbody>
                                       <tr>
                                           <td width="30%" valign="center" style="width: 30%;background: rgb(12, 78, 162)">
                                               <p style="text-align:center">
                                                   <strong><span style="font-family: Arial;color: rgb(255, 255, 255);font-size: 16px">
                                                        Диаметр
                                                   </span></strong>
                                               </p>
                                           </td>
                                           <td valign="center" style="">
                                               <p style="text-align:center">
                                                   <span style="font-family: Arial;font-size: 16px;color:#666;">1.2, 1.6 mm</span>
                                               </p>
                                           </td>
                                           <td valign="center" style="">
                                               <p style="text-align:center">
                                                   <span style="font-family: Arial;font-size: 16px;color:#666;">2.4,2.8,3.2 mm</span>
                                               </p>
                                           </td>
                                           <td valign="center" style="">
                                               <p style="text-align:center">
                                                   <span style="font-family: Arial;font-size: 16px;color:#666;">2.4,2.8,3.2,4.0 mm</span>
                                               </p>
                                           </td>
                                          
                                       </tr>
                                       <tr>
                                           <td width="30%" valign="center" style="border-top: none;width: 30%;background: rgb(12, 78, 162)">
                                               <p style="text-align:center">
                                                   <strong><span style="font-family: Arial;color: rgb(255, 255, 255);font-size: 16px">
                                                       Упаковка
                                                   </span></strong>
                                               </p>
                                           </td>
                                           <td valign="center" style="border-top: none;">
                                               <p style="text-align:center">
                                                   <span style="font-family: Arial;font-size: 16px;color:#666;">15 кг/Катушка</span>
                                               </p>
                                           </td>
                                           <td valign="center" style="border-top: none;">
                                               <p style="text-align:center">
                                                   <span style="font-family: Arial;font-size: 16px;color:#666;">20 или 50кг/катушка</span>
                                               </p>
                                           </td>
                                           <td valign="center" style="border-top: none;">
                                               <p style="text-align:center">
                                                   <span style="font-family: Arial;font-size: 16px;color:#666;">100~250 кг/бочка</span>
                                               </p>
                                           </td>
                                          
                                       </tr>
                                       
                                   </tbody>
                               </table>
				<h3>Применение продукции</h3>
				<div class="swiper-container">
				    <div class="swiper-wrapper">
				        <div class="swiper-slide" style="background: #efefef;" v-for="(item,index) in lbList" :key="index">
				           <img class="w100" :src="item.show_img" alt="" >
							
				        </div>
						
				    </div>
				    <div class="swiper-pagination1"></div>
					
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Swiper from 'swiper';
	import axios from 'axios';
	export default {
		data() {
			return {
				lbList:[
					
				    
				    
				    
				],
                category: {cat_id: "", cat_name: "",description:''},
                
				tips3List:[
					{
						imgsrc:require('@/assets/images/welding/welding1.png'),
						name:'Gas shielding welding wire',
						text:'Various gas shielding repairing welding wires ( repair all kinds of wear parts ) . Heat resistant  welding wire, grate bar and single tooth roller repairing welding wire, gas shielding welding wire, impact resistant welding wire and various welding wires containing special elements.',
					},
					{
						imgsrc:require('@/assets/images/welding/welding2.png'),
						name:'Wear plate welding wire',
						text:'We develop our wear resistant flux cored welding wires always according to plate’s characteristics.This guarantee good performance regarding no clearing slag, low welding spatter, smooth surface, high welding efficiency and a transition coefficient aboce 0.9.',
					},
				    {
						imgsrc:require('@/assets/images/welding/welding3.png'),
						name:'Vertical cement mill welding wire',
						text:'Our company is also specialized in manufacturing Vertical Cement Mill Welding Wires (HB series).These sene’s models have excellent welding performance and present great welding forming and low welding spatter.',
					},
				    {
						imgsrc:require('@/assets/images/welding/welding4.png'),
						name:'Cement squeeze roller welding...',
						text:'Our company developed special Squeeze roller welding wires. We can guarantee high hardness and abrasion resistance after repairing, resulting in a service life no less than 8000 hours.',
					},
				    {
						imgsrc:require('@/assets/images/welding/welding5.png'),
						name:'Steel mill roller welding wire',
						text:'Steel mill roller welding wire can flexibly adjust alloy composition in a wide range, especially for high-carbon and high-alloy rolls that are difficult to forge, it is more advantageous in surfacing welding.',
					},
				    
				   
				    
				    
				],
				
			}
			
		},
		methods:{
			golink(id){
				const routeUrl = this.$router.resolve({
					path: "/detail",
					query: { id: id },
				});	
				window.open(routeUrl.href, "_self");
			}
		},
		mounted(){
			var that = this;
			axios({
				method: 'post',
				url:`${this.$apiYf}/anlistapi.php`,
				data: {
					catid:5
				},
				headers: {'Content-Type': 'multipart/form-data'},
			}).then((res) =>{
				console.log(res)
			    that.tips3List = res.data.productc_list;
			});
            axios({
            	method: 'post',
            	url:`${this.$apiYf}/anlicategoryapi.php`,
            	data: {
            		cid:5
            	},
            	headers: {'Content-Type': 'multipart/form-data'},
            }).then((res) =>{
            	console.log(res)
                that.category = res.data.category;
            });
			axios({
				method: 'post',
				url:`${this.$apiYf}/indexlunboapi.php`,
				data: {
					cid:15
				},
				headers: {'Content-Type': 'multipart/form-data'},
			}).then((res) =>{
				console.log(res)
			    that.lbList = res.data.lunboinfo;
			    that.$nextTick(() => {
			        that.kvSwiper = new Swiper ('.swiper-container', {
			            loop: true, 
			            autoplay: {
			                delay: 3000,
			                disableOnInteraction: false,
			            },
			            pagination: {
			                el: '.swiper-pagination1',
			                clickable: true,
			            },
			            navigation: {
			                nextEl: '.swiper-button-next1',
			                prevEl: '.swiper-button-prev1',
			                clickable: true,
			            },
			            centeredSlides: true,
			            slidesPerView: 3,
			            spaceBetween: 30,
			            speed: 500,
			            roundLengths : true, 
			            observer:true,
			            observeParents:true,
			            observeSlideChildren:true,
			            calculateHeight: true,
			            on:{
			                
			                slideChangeTransitionEnd: function(){ 
			                    
			                }  
			              },
			        });
			    })
			});
		}
	
	}
</script>

<style lang="scss">
    .cotent_weld{
        .content_center{
        	width:100%;
        	h3{font-size: 48px;color: #0c4fa2;margin: 4vw 0 2.5vw;text-align: left;
        		position: relative;line-height: 1.8;
        		&::after{
        			content: '';
        			border-bottom: solid 4px #0c4fa2;width: 120px;position: absolute;bottom: 0;left:0;
        		}
        	}
        	h4{
        		font-size: 20px;color:#333;margin-bottom: 1vw;
        	}
        	p{
        		font-size: 16px;line-height: 2;color: #666;
        	}
        }
        .list_box{background: #0c4fa2;padding: 4vw 0;
            h3{font-size: 48px;color: #fff;margin: 0vw 0 4vw;text-align: left;
                position: relative;line-height: 1.8;
                &::after{
                    content: '';
                    border-bottom: solid 4px #fff;width: 120px;position: absolute;bottom: 0;left:0;
                }
            }
        	ul{display: flex;flex-wrap: wrap;justify-content: center;
        		li{width: 25%;font-size: 20px;color: #fff;text-align: center;position: relative;
        			&::after{width: 1px;height: 4vw;background: #8dacd3;position: absolute;right:0;top:0;bottom:0;margin: auto;content: "";}
        			&:last-child::after{
        				width:0;
        			}
        			&:hover{
        				img{animation: jump 0.5s ease-in-out infinite;}
        				
        			}
        			p.ts{font-size: 16px;margin-bottom: 0px;text-align: left;padding: 0 1em 0 2em;}
        			h4{font-size: 18px;margin:16px 0;
        				span{font-size: 16px;}
        			}
        		}
        	}
        }
        
        .tips3{
        	background: #e4f0fa;padding: 5vw 0;margin-top: 4vw;
        	h3{
        		font-size: 43px;margin-bottom: 2.5vw;
        		color: #0c4fa2;position: relative;line-height: 1.8;
        		&::after{
        			content: '';
        			border-bottom: solid 4px #0c4fa2;width: 120px;position: absolute;bottom: 0;left:0;
        		}
        	}
        	.tips3List{
        		display: flex;flex-wrap: wrap;
        		li{width: 30%;margin-bottom: 60px;margin-right: 5%;
        			&:nth-child(3n){
        				margin-right: 0;
        			}
        			.tisp3_img{background: #fff;}
        			.text_bottom{background: #fff;padding: 28px;height: 290px;position: relative;
        				.tips3_text{
        					h4{font-size: 24px;color: #000;margin-bottom: 16px;white-space: nowrap;
        					overflow: hidden;text-overflow:ellipsis;}
        					p{font-size: 14px;color: #666;white-space: pre-wrap;
        					overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 7;-webkit-box-orient: vertical;
        					line-height: 20px;}
        					@media (max-width: 1440px) {
        					    h4{font-size: 20px;}
        						p{font-size: 13px;color: #666;line-height: 20px;}
        						
        					}
        					
        				}
        				.buttom{
        					position: absolute;left: 28px;bottom: 28px;display: flex;cursor: pointer;
        					span{line-height: 26px;color: #0c4fa2;border: solid 2px #0c4fa2;display: inline-block;
        						padding: 0 14px;margin-left: 4px;
        					}
        					&:hover{
        						span{background: #0c4fa2;color: #fff;}
        					}
        				}
        			}
        		}
        	}
        }
        .pro_box{
        	h3{font-size: 48px;color: #0c4fa2;margin: 4vw 0 2.5vw;text-align: left;
        		position: relative;line-height: 1.8;
        		&::after{
        			content: '';
        			border-bottom: solid 4px #0c4fa2;width: 120px;position: absolute;bottom: 0;left:0;
        		}
        	}
        	
        	p{
        		font-size: 16px;line-height: 2;color: #666;
        	}
        	ul{
        		display: flex;justify-content: space-between;flex-wrap: wrap;
        		li{
        			width:49%;padding: 2%;border: solid 1px #858585;margin-bottom: 2.5vw;
        			.pro_text{
        				font-size: 24px;color: #0c4fa2;margin-bottom: 20px;font-weight: bold;
        					p{font-size: 14px;line-height: 1.5;margin-top: 20px;}
        				}
        		
        		}
        	}
        	.swiper-container{margin-bottom: 5vw;}
        	.swiper-pagination1{text-align: center;margin: 1vw 0;
        		.swiper-pagination-bullet{opacity: 0.5;margin: 0 10px;}
        		.swiper-pagination-bullet-active{color: #0c4fa2;opacity: 1;}
        	}	
        	.swiper-button-prev1{width: 121px;height: 51px;background: url(../../assets/images/cco/cco_aal.png) no-repeat center 100%;
        		position: absolute;left: 0;bottom: 5px;
        		&:hover{
        			background: url(../../assets/images/cco/cco_aal1.png) no-repeat center 100%;
        		}
        	}
        	.swiper-button-next1{width: 121px;height: 51px;background: url(../../assets/images/cco/cco_aar.png) no-repeat center 100%;
        		position: absolute;right: 0;bottom: 5px;
        		&:hover{
        			background: url(../../assets/images/cco/cco_aar1.png) no-repeat center 100%;
        		}
        	}
        }
        
    }
	
</style>